__turbopack_context__.v({
  "carousel": "logos_carousel-module-scss-module__PzytBG__carousel",
  "logo": "logos_carousel-module-scss-module__PzytBG__logo",
  "scroll": "logos_carousel-module-scss-module__PzytBG__scroll",
  "track": "logos_carousel-module-scss-module__PzytBG__track",
});
